import React from "react";
import { FormControl, MenuItem, Select, Stack } from "@mui/material";
import styled from "styled-components";

const StyledMenuItem = styled(MenuItem)`
    font-size: 12px;
`;

const WorkflowPicker = ({ workflow, setWorkflow, data }) => {
    if (!data || data.length === 0) return null;
    if (!workflow) return null;
    const handleWorkflowChange = (event) => {
        setWorkflow(event.target.value);
    };

    return (
        <Stack
            direction="column"
            sx={{
                width: "100%",
                typography: "body1",
            }}
            spacing={2}
            justifyContent="space-between"
        >
            <Stack direction="row" alignItems="center">
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <Select
                        value={workflow}
                        onChange={handleWorkflowChange}
                        displayEmpty
                        inputProps={{ "aria-label": "select team" }}
                        sx={{ fontSize: 12 }}
                    >
                        {Object.keys(data).map((item) => {
                            return <StyledMenuItem value={item}>{item}</StyledMenuItem>;
                        })}
                    </Select>
                </FormControl>
            </Stack>
        </Stack>
    );
};

export default WorkflowPicker;
